import { render, staticRenderFns } from "./LogicTree.vue?vue&type=template&id=45903f82&scoped=true"
import script from "./LogicTree.vue?vue&type=script&lang=js"
export * from "./LogicTree.vue?vue&type=script&lang=js"
import style0 from "./LogicTree.vue?vue&type=style&index=0&id=45903f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45903f82",
  null
  
)

export default component.exports